import qs from 'qs';
import ApiResourceManager from '../ApiResourceManager';

export default class ModifiersManager extends ApiResourceManager {
  create = (data) =>
    this.request({
      method: 'POST',
      url: '/modifiers',
      data,
    });

  update = (id, data) =>
    this.request({
      method: 'PUT',
      url: `/modifiers/${id}`,
      data,
    });

  delete = (ids, isMaster) =>
    this.request({
      method: 'DELETE',
      url: '/modifiers',
      data: {
        ids,
        is_master: isMaster,
      },
    });

  reorder = (modifierGroupId, items) =>
    this.request({
      method: 'PUT',
      url: `/modifier-groups/${modifierGroupId}/modifiers-order`,
      data: {
        items,
      },
    });

  toggleAvailable = (modifierId, val) =>
    this.request({
      method: 'PATCH',
      url: `/modifiers/${modifierId}`,
      data: {
        fields: ['is_available'],
        is_available: val,
      },
    });

  toggleVisible = (modifierId, val) =>
    this.request({
      method: 'PATCH',
      url: `/modifiers/${modifierId}`,
      data: {
        fields: ['is_visible'],
        is_visible: val,
      },
    });

  get = (params) =>
    this.request({
      method: 'GET',
      url: '/modifiers',
      params,
      paramsSerializer: qs.stringify,
    });

  show = (id) =>
    this.request({
      method: 'GET',
      url: `/modifiers/${id}`,
    });
}
